import React from "react";

const About: React.FC = () => {
  return (
    <div className="max-w-2xl">
      <h1 className="text-2xl sm:text-3xl font-bold mb-6 sm:mb-8 font-mono">
        About
      </h1>

      <div className="space-y-4 sm:space-y-6 font-mono text-sm leading-relaxed">
        <p>
          I'm an assistant professor at Yildiz Technical University, department
          of Artificial Intelligence and Data Engineering. My research focuses
          on the intersection of machine learning and video coding.
        </p>

        <p>
          I have been teaching fundamental courses on machine learning and
          software engineering since Fall 2025.
        </p>
      </div>

      {/* Education */}
      <div className="mt-8 sm:mt-12">
        <h2 className="text-lg sm:text-xl font-bold mb-3 sm:mb-4 font-mono">
          Education
        </h2>
        <div className="space-y-3 font-mono text-sm">
          <div className="border-l-2 border-black pl-4">
            <div className="font-bold">Ph.D. Computer Science - 2023</div>
            <div className="text-gray-600">Klagenfurt University</div>
          </div>
          <div className="border-l-2 border-black pl-4">
            <div className="font-bold">M.Sc. Computer Science - 2019</div>
            <div className="text-gray-600">Ozyegin University</div>
          </div>
          <div className="border-l-2 border-black pl-4">
            <div className="font-bold">B.Sc. Computer Science - 2018</div>
            <div className="text-gray-600">Ozyegin University</div>
          </div>
        </div>
      </div>

      {/* Skills */}
      <div className="mt-8 sm:mt-12">
        <h2 className="text-lg sm:text-xl font-bold mb-3 sm:mb-4 font-mono">
          Key Areas
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 sm:gap-4 font-mono text-sm">
          <div>
            <div className="font-bold border-b border-black pb-1 mb-2">
              Research
            </div>
            <ul className="space-y-1">
              <li>• Machine Learning</li>
              <li>• Computer Vision</li>
              <li>• Video Coding</li>
              <li>• Deep Learning</li>
            </ul>
          </div>
          <div className="mt-4 sm:mt-0">
            <div className="font-bold border-b border-black pb-1 mb-2">
              Industry
            </div>
            <ul className="space-y-1">
              <li>• AI Consulting</li>
              <li>• Product Development</li>
              <li>• Team Leadership</li>
              <li>• Technical Writing</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
